import { SubTitle, Collapse, styled, CommonStyles, Image } from '@teko/ds-desktop';
import React from 'react';
import { t } from '../../i18n.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PolicyAndService = (_a) => {
  var _b = _a, {
    title,
    information,
    maxPolicyAndService = 5
  } = _b, rest = __objRest(_b, [
    "title",
    "information",
    "maxPolicyAndService"
  ]);
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadValues({}, rest), /* @__PURE__ */ React.createElement(SubTitle, {
    level: 2,
    weight: "medium",
    marginBottom: "s8"
  }, title), /* @__PURE__ */ React.createElement(Collapse, {
    items: information,
    max: maxPolicyAndService,
    showText: t("Xem th\xEAm"),
    hideText: t("R\xFAt g\u1ECDn"),
    render: (item, index) => /* @__PURE__ */ React.createElement(Policy, {
      key: index
    }, typeof item.icon === "string" ? /* @__PURE__ */ React.createElement(StyledIcon, {
      width: 24,
      height: 24,
      src: item.icon
    }) : item.icon, /* @__PURE__ */ React.createElement(Content, {
      className: `att-policy-content-${index}`,
      dangerouslySetInnerHTML: {
        __html: item.content
      }
    }))
  }));
};
const Wrapper = styled.div`
  ${CommonStyles};
  background-color: #fff;
  border-radius: 0.5rem;
`;
const Policy = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 12px;
`;
const Content = styled.div`
  & > * {
    margin: 0;
  }
`;
const StyledIcon = styled(Image)`
  min-width: 24px;
`;

export { PolicyAndService };
